import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    loadPwaPushNotificationSettingsError,
    loadPwaPushNotificationSettingsSuccess,
    pushSubscriptionHealthy,
    pushSubscriptionInactive,
    savePwaPushNotificationSettings,
    subscribeToPushNotifications,
    subscribeToPushNotificationsFailure,
    subscribeToPushNotificationsSuccess,
} from '../actions/pwa-push-notification.actions';
import {
    initialPwaPushNotificationState,
    PushSubscriptionHealth,
    PwaPushNotificationState,
} from '../pwa-push-notification.state';

export function updateSettingsAndSetStatusToLoaded(
    state: Readonly<PwaPushNotificationState>,
    { settings }: Pick<PwaPushNotificationState, 'settings'>,
): Readonly<PwaPushNotificationState> {
    return { ...state, settings, status: LoadStatus.Loaded };
}

export function setErrorInState(state: Readonly<PwaPushNotificationState>): Readonly<PwaPushNotificationState> {
    return { ...state, status: LoadStatus.Error };
}

export function setSubscriptionHealth(
    state: Readonly<PwaPushNotificationState>,
    subscriptionHealth: PushSubscriptionHealth,
): Readonly<PwaPushNotificationState> {
    return { ...state, subscriptionHealth };
}

const createPwaPushNotificationReducer = createReducer(
    initialPwaPushNotificationState,
    on(loadPwaPushNotificationSettingsSuccess, savePwaPushNotificationSettings, updateSettingsAndSetStatusToLoaded),
    on(loadPwaPushNotificationSettingsError, setErrorInState),
    on(subscribeToPushNotifications, (state) => setSubscriptionHealth(state, PushSubscriptionHealth.Renewing)),
    on(subscribeToPushNotificationsSuccess, pushSubscriptionHealthy, (state) =>
        setSubscriptionHealth(state, PushSubscriptionHealth.Subscribed),
    ),
    on(subscribeToPushNotificationsFailure, pushSubscriptionInactive, (state) =>
        setSubscriptionHealth(state, PushSubscriptionHealth.NotSubscribed),
    ),
);

export function pwaPushNotificationReducer(
    state: Readonly<PwaPushNotificationState> | undefined,
    action: Action,
): Readonly<PwaPushNotificationState> {
    return createPwaPushNotificationReducer(state, action);
}
